(function () {
  var section = document.querySelector(".ib-pdp");
  if (!section) return;

  var slides = section.querySelectorAll(".ib-savor-pdp__main-img");
  var thumbs = section.querySelectorAll(".ib-savor-pdp__thumb");
  var prev = section.querySelector(".ib-savor-pdp__arrow--prev");
  var next = section.querySelector(".ib-savor-pdp__arrow--next");
  var current = 0;

  function showSlide(index) {
    if (!slides.length) return;
    current = (index + slides.length) % slides.length;
    slides.forEach(function (img, i) {
      img.classList.toggle("--active", i === current);
      img.setAttribute("aria-hidden", i === current ? "false" : "true");
    });
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle("--active", i === current);
      thumb.setAttribute("aria-selected", i === current ? "true" : "false");
    });
  }

  function bundleKeyFromTitle(title) {
    var t = String(title || "").toLowerCase();
    if (/\b6\b/.test(t)) return "6";
    if (/\b3\b/.test(t)) return "3";
    return "1";
  }

  function findBundleSlide(bundleKey) {
    // Prefer studio "*-bottle_bundle*" style shots when several matches exist
    var preferred = -1;
    var fallback = -1;
    slides.forEach(function (img, i) {
      if (img.getAttribute("data-bundle") !== bundleKey) return;
      var src = (img.getAttribute("src") || img.currentSrc || "").toLowerCase();
      if (fallback < 0) fallback = i;
      if (src.indexOf("bottle_bundle") !== -1 || src.indexOf("bottle-bundle") !== -1) {
        if (preferred < 0) preferred = i;
      }
    });
    if (preferred >= 0) return preferred;
    if (fallback >= 0) return fallback;
    // Filename fallback if data-bundle missing (preview / older markup)
    for (var i = 0; i < slides.length; i++) {
      var s = (slides[i].getAttribute("src") || slides[i].currentSrc || "").toLowerCase();
      if (bundleKey === "6" && (s.indexOf("6-bottle") !== -1 || s.indexOf("6_bottle") !== -1 || s.indexOf("-6x") !== -1 || s.indexOf("_6x") !== -1)) return i;
      if (bundleKey === "3" && (s.indexOf("3-bottle") !== -1 || s.indexOf("3_bottle") !== -1 || s.indexOf("-3x") !== -1 || s.indexOf("_3x") !== -1)) return i;
    }
    return bundleKey === "1" ? 0 : -1;
  }

  function showBundleForVariant(title) {
    var key = bundleKeyFromTitle(title);
    var index = findBundleSlide(key);
    if (index < 0 && key !== "1") index = 0;
    if (index >= 0) showSlide(index);
  }

  if (prev) prev.addEventListener("click", function () { showSlide(current - 1); });
  if (next) next.addEventListener("click", function () { showSlide(current + 1); });
  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      showSlide(Number(thumb.getAttribute("data-slide") || 0));
    });
  });
  showSlide(0);

  function formatMoney(cents) {
    var n = Number(cents) || 0;
    if (n > 1000) return "$" + (n / 100).toFixed(2);
    // already dollars from data-price sometimes
    if (String(cents).indexOf(".") !== -1) return "$" + Number(cents).toFixed(2);
    return "$" + (n / 100).toFixed(2);
  }

  function moneyFromAttr(raw) {
    var n = Number(raw || 0);
    // Shopify liquid money amounts in data attrs are cents for variant.price
    return "$" + (n / 100).toFixed(2);
  }

  var variantInput = section.querySelector("[data-variant-input]");
  var priceSale = section.querySelector("[data-price-sale]");
  var priceRegular = section.querySelector("[data-price-regular]");
  var priceCompare = section.querySelector("[data-price-compare]");
  var priceBadge = section.querySelector("[data-price-badge]");
  var saleBubble = section.querySelector("[data-sale-bubble]");
  var addBtn = section.querySelector("[data-atc]");
  var sticky = document.querySelector("[data-sticky-atc]");
  var stickyPrice = document.querySelector("[data-sticky-price]");
  var stickyVariant = document.querySelector("[data-sticky-variant]");
  var stickySubmit = document.querySelector("[data-sticky-submit]");
  var form = section.querySelector("#ib-pdp-form");
  var forceSoldOut = section.getAttribute("data-force-sold-out") === "true";

  // Keep gallery Sale sticker if any pack is discounted (matches collection cards)
  var productOnSale = section.getAttribute("data-product-on-sale") === "true";
  if (!productOnSale) {
    section.querySelectorAll(".ib-pdp__variant-pill input").forEach(function (input) {
      var p = Number(input.getAttribute("data-price") || 0);
      var c = Number(input.getAttribute("data-compare") || 0);
      if (c > p) productOnSale = true;
    });
  }

  function applyVariant(input) {
    if (!input) return;
    var id = input.getAttribute("data-variant-id") || input.value;
    var price = Number(input.getAttribute("data-price") || 0);
    var compare = Number(input.getAttribute("data-compare") || 0);
    var title = input.getAttribute("data-title") || "";
    var available = !forceSoldOut && input.getAttribute("data-available") !== "false";
    var variantOnSale = !forceSoldOut && compare > price;

    if (variantInput) variantInput.value = id;

    section.querySelectorAll(".ib-pdp__variant-pill").forEach(function (pill) {
      var radio = pill.querySelector("input");
      pill.classList.toggle("--active", !!(radio && radio.checked));
    });

    if (priceSale) {
      priceSale.textContent = moneyFromAttr(price);
      priceSale.hidden = !variantOnSale;
    }
    if (priceRegular) {
      priceRegular.textContent = moneyFromAttr(price);
      priceRegular.hidden = variantOnSale;
    }
    if (priceCompare) {
      if (variantOnSale) {
        priceCompare.innerHTML = "<s>" + moneyFromAttr(compare) + "</s>";
        priceCompare.hidden = false;
      } else {
        priceCompare.innerHTML = "";
        priceCompare.hidden = true;
      }
    }
    if (priceBadge) priceBadge.hidden = !variantOnSale;
    // Sticker stays on for the whole product when multi-packs are on sale
    if (saleBubble) saleBubble.hidden = forceSoldOut || !(productOnSale || variantOnSale);

    if (stickyPrice) stickyPrice.textContent = moneyFromAttr(price);
    if (stickyVariant && title) stickyVariant.textContent = title;

    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? "Add to cart" : "Sold out";
    }
    if (stickySubmit) {
      stickySubmit.disabled = !available;
      stickySubmit.textContent = available ? "Add to cart" : "Sold out";
    }

    showBundleForVariant(title);
  }

  section.querySelectorAll(".ib-pdp__variant-pill input").forEach(function (input) {
    input.addEventListener("change", function () {
      applyVariant(input);
    });
  });

  var qtyInput = section.querySelector("[data-qty-input]");
  var qtyMinus = section.querySelector("[data-qty-minus]");
  var qtyPlus = section.querySelector("[data-qty-plus]");

  function setQty(n) {
    if (!qtyInput) return;
    var next = Math.max(1, Number(n) || 1);
    qtyInput.value = String(next);
  }

  if (qtyMinus) qtyMinus.addEventListener("click", function () { setQty(Number(qtyInput.value) - 1); });
  if (qtyPlus) qtyPlus.addEventListener("click", function () { setQty(Number(qtyInput.value) + 1); });
  if (qtyInput) qtyInput.addEventListener("change", function () { setQty(qtyInput.value); });

  if (stickySubmit && form) {
    stickySubmit.addEventListener("click", function () {
      if (forceSoldOut || stickySubmit.disabled) return;
      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.submit();
    });
  }

  if (form && forceSoldOut) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
    });
  }

  // Description / Ingredients / Directions — fixed tab row
  document.querySelectorAll("[data-ib-accordions]").forEach(function (root) {
    var tabs = root.querySelectorAll("[data-accordion-tab]");
    var panels = root.querySelectorAll("[data-accordion-panel]");
    if (!tabs.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle("--active", on);
        tab.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle("--active", on);
        if (on) panel.removeAttribute("hidden");
        else panel.setAttribute("hidden", "");
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activate(Number(tab.getAttribute("data-accordion-tab") || 0));
      });
    });
  });

  // Show sticky bar once the main Add to cart control scrolls off-screen
  // (same trigger as local preview — every IB PDP shares this script)
  if (sticky) {
    sticky.hidden = false;
    var buyPanel = section.querySelector("[data-buy-panel]") || section.querySelector(".ib-savor-pdp__buy");
    var atc = section.querySelector("[data-atc]");
    var target = atc || buyPanel;

    function syncStickyVisibility() {
      if (!target) {
        sticky.classList.add("--visible");
        return;
      }
      var rect = target.getBoundingClientRect();
      // Match IntersectionObserver rootMargin: -80px top
      var inView = rect.bottom > 80 && rect.top < window.innerHeight;
      sticky.classList.toggle("--visible", !inView);
    }

    if (target && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle("--visible", !entry.isIntersecting);
          });
        },
        { rootMargin: "-80px 0px 0px 0px", threshold: 0 }
      );
      observer.observe(target);
    } else {
      window.addEventListener("scroll", syncStickyVisibility, { passive: true });
      window.addEventListener("resize", syncStickyVisibility);
    }

    // Initial state after layout (images / sticky header)
    syncStickyVisibility();
    window.addEventListener("load", syncStickyVisibility);
  }
})();

/* Recommendations horizontal scroll — outside .ib-pdp, so init separately */
(function () {
  document.querySelectorAll("[data-ib-recs]").forEach(function (root) {
    if (root.dataset.recsInit === "true") return;
    root.dataset.recsInit = "true";

    var track = root.querySelector("[data-ib-recs-track]");
    var prev = root.querySelector("[data-ib-recs-prev]");
    var next = root.querySelector("[data-ib-recs-next]");
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector(".ib-pdp__rec-card");
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      // Hide nav when everything fits
      var nav = root.querySelector(".ib-pdp__recs-nav");
      if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 2;
    }

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
    track.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();
  });

  /* Hide Yotpo review cards below 4 stars (keep 4★ and 5★ only) */
  (function initYotpoHighStarOnly() {
    var root = document.getElementById("ib-yotpo-reviews");
    if (!root) return;

    var timer = null;
    var MIN_STARS = 4;

    function cardNodes() {
      var cards = root.querySelectorAll(
        ".yotpo-review-card, .yotpo-review, li.yotpo-review-card, .yotpo-reviews-list > li"
      );
      if (!cards.length) {
        cards = root.querySelectorAll(".card-container");
      }
      return Array.prototype.slice.call(cards);
    }

    function ratingFrom(el) {
      var labeled =
        el.getAttribute("aria-label") ||
        (el.querySelector &&
          (function () {
            var n = el.querySelector("[aria-label*='Rating'], [aria-label*='out of 5']");
            return n ? n.getAttribute("aria-label") : "";
          })()) ||
        "";
      var m =
        labeled.match(/Rating:\s*(\d+(?:\.\d+)?)\s*out of\s*5/i) ||
        labeled.match(/(\d+(?:\.\d+)?)\s*out of\s*5\s*stars?/i);
      if (m) return parseFloat(m[1], 10);

      /* Fallback: count filled star icons in the card */
      var filled = el.querySelectorAll(
        ".yotpo-star-rating-icon--full, .yotpo-star--full, [class*='star'][class*='full'], .yotpo-review-stars .sr-only"
      );
      if (filled.length) return filled.length;

      var scoreEl = el.querySelector("[itemprop='ratingValue'], .yotpo-review-score, [data-score]");
      if (scoreEl) {
        var raw =
          scoreEl.getAttribute("content") ||
          scoreEl.getAttribute("data-score") ||
          (scoreEl.textContent || "").trim();
        var n = parseFloat(raw, 10);
        if (!isNaN(n) && n >= 1 && n <= 5) return n;
      }
      return null;
    }

    function hideTarget(el) {
      /* Prefer the whole list item / review card, not just the inner card-container */
      if (el.classList.contains("card-container")) {
        return el.closest(".yotpo-review-card, .yotpo-review, li") || el;
      }
      return el;
    }

    function apply() {
      cardNodes().forEach(function (el) {
        var rating = ratingFrom(el);
        if (rating == null) return;
        var target = hideTarget(el);
        if (rating < MIN_STARS) {
          /* Remove from the list so Yotpo masonry can pack 4–5★ cards tightly */
          if (target.parentNode) target.parentNode.removeChild(target);
        }
      });
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(apply, 100);
    }

    var observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
    schedule();
    setTimeout(schedule, 800);
    setTimeout(schedule, 2500);
  })();

  /* Load more once: first click loads next batch, then button is removed for good. */
  (function initYotpoLoadMoreOnce() {
    var root = document.getElementById("ib-yotpo-reviews");
    if (!root) return;

    var used = false;

    function scrubExtras() {
      root.querySelectorAll(".ib-yotpo-load-less").forEach(function (el) {
        el.remove();
      });
      if (!used) return;
      root.querySelectorAll(
        ".yotpo-reviews-pagination-container, .yotpo-vertical-pagination, .yotpo-reviews-pagination-item, .yotpo-vertical-pagination-item, [aria-label='Load more reviews']"
      ).forEach(function (el) {
        el.remove();
      });
    }

    function markUsed() {
      if (used) return;
      used = true;
      root.classList.add("ib-yotpo-load-more-used");
      /* Let Yotpo finish its fetch, then remove any remaining Load more UI */
      setTimeout(scrubExtras, 400);
      setTimeout(scrubExtras, 1200);
      setTimeout(scrubExtras, 2500);
    }

    root.addEventListener(
      "click",
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        var more = t.closest(
          ".yotpo-reviews-pagination-item, .yotpo-vertical-pagination-item, [aria-label='Load more reviews']"
        );
        if (!more) return;
        if (used) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          scrubExtras();
          return;
        }
        markUsed();
      },
      true
    );

    var observer = new MutationObserver(scrubExtras);
    observer.observe(root, { childList: true, subtree: true });
    scrubExtras();
  })();

  /* FDA disclaimer: ensure * + quiet style even if product HTML varies */
  (function styleFdaDisclaimers() {
    var needle = /these statements have not been evaluated by the food and drug administration/i;
    document.querySelectorAll(".ib-pdp__accordion-panel em, .ib-pdp__accordion-panel p").forEach(function (el) {
      var text = (el.textContent || "").trim();
      if (!needle.test(text)) return;
      if (el.tagName === "P") {
        var onlyEm = el.querySelector("em");
        if (onlyEm && needle.test(onlyEm.textContent || "")) el = onlyEm;
        else if (!onlyEm) {
          var wrap = document.createElement("em");
          wrap.className = "ib-pdp__fda-disclaimer";
          wrap.textContent = (text.charAt(0) === "*" ? text : "* " + text);
          el.textContent = "";
          el.appendChild(wrap);
          return;
        }
      }
      el.classList.add("ib-pdp__fda-disclaimer");
      if (text.charAt(0) !== "*") {
        el.textContent = "* " + text;
      }
    });
  })();

  /* Replace any leftover em/en dashes in visible PDP copy (blurbs, description, etc.) */
  (function replaceEmDashes() {
    var root = document.querySelector("#buy") || document.getElementById("main");
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (!value || (value.indexOf("\u2014") === -1 && value.indexOf("\u2013") === -1)) continue;
      node.nodeValue = value
        .replace(/\u2014/g, " - ")
        .replace(/\u2013/g, " - ")
        .replace(/ {2,}- {2,}/g, " - ")
        .replace(/ - {2,}/g, " - ")
        .replace(/ {2,}- /g, " - ");
    }
  })();
})();
